import React, { useState } from 'react'
import { useSelector } from 'react-redux'

import { Pill } from '@/components/pills/Pill'
import { Accordion } from '@/components/accordions/Accordion'
import { getScoreThreshold } from '../helpers'

const scoreThresholdToPillProps = {
  exceeds_threshold: { success: true },
  meets_threshold: { warning: true },
  improvement_threshold: { caution: true },
  failure: { critical: true },
}

export const ScoreAccordion = ({
  score = 0,
  title = 'My section',
  children,
  sectionData = null,
  getNotableCalls,
  aggregateSection = false,
  showAllAccordions = false,
}) => {
  const [active, setActive] = useState(false)
  const { data } = useSelector((state) => state.scorecards)

  const handleToggle = () => {
    if (!active && aggregateSection) {
      getNotableCalls(sectionData, data.targetScorecardConfig, score)
    }
    setActive(!active)
  }

  const scoreColorProps = aggregateSection
    ? scoreThresholdToPillProps[getScoreThreshold(score, data.targetScorecardConfig)]
    : {}

  return (
    <Accordion
      styled
      id="score-accordion"
      expanded={showAllAccordions || active}
      handleToggle={handleToggle}
      title={title}
      className="mbs"
      actions={
        <Pill emphasized {...scoreColorProps} data-testid="score-accordion-score-section">
          {`${score}%`}
        </Pill>
      }
    >
      {children}
    </Accordion>
  )
}
